import * as fetchBooking from "./fetchBooking";
import * as booking from "./booking";
import * as fetchAmenities from "./fetchAmenitiesList";
import * as deleteBooking from "./deleteBooking";
import { initialState as bookingInitialState, BookingRequestInfoState } from "./booking";
import { initialState as fetchBookingInitialState, FetchBookingInfoState } from "./fetchBooking";
import { initialState as fetchAmenitiesInitialState, FetchAmenityInfoState } from "./fetchAmenitiesList";
import { initialState as deleteBookingInitialState, DeleteBookingRequestInfoState } from "./deleteBooking";
import reduceReducers from "reduce-reducers";


export const Types: { [key: string]: any } = {
    ...fetchBooking.Types,
    ...booking.Types,
    ...fetchAmenities.Types,
    ...deleteBooking.Types
};

export const Actions: { booking: typeof booking.Actions, fetchBooking: typeof fetchBooking.Actions, fetchAmenities: typeof fetchAmenities.Actions, deleteBooking: typeof deleteBooking.Actions } = {
    booking: booking.Actions,
    fetchBooking: fetchBooking.Actions,
    fetchAmenities: fetchAmenities.Actions,
    deleteBooking: deleteBooking.Actions
};

export const bookingRequestReducer = reduceReducers<BookingRequestInfoState>(
    bookingInitialState,
    booking.default as any
);

export const fetchBookingRequestReducer = reduceReducers<FetchBookingInfoState>(
    fetchBookingInitialState,
    fetchBooking.default as any
);

export const fetchAmenitiesListReducer = reduceReducers<FetchAmenityInfoState>(
    fetchAmenitiesInitialState,
    fetchAmenities.default as any
);

export const deleteBookingRequestReducer = reduceReducers<DeleteBookingRequestInfoState>(
    deleteBookingInitialState,
    deleteBooking.default as any
);

export default {
    booking: bookingRequestReducer,
    fetchBooking: fetchBookingRequestReducer,
    fetchAmenities: fetchAmenitiesListReducer,
    deleteBooking: deleteBookingRequestReducer
};